import styled from 'styled-components';
import Translator from '@/layout/components/helpers/Translator';
import wlv2 from '@/assets/images/wlv2.png';
import { useParams } from 'react-router-dom';

export default function SsoLoginScreen() {
  const { client } = useParams();
  return (
    <Container>
      <img src={wlv2} />
      <h4>
        <Translator
          file="user"
          name="user-loggin.sso-access-worldlexnet-active-directory"
        />
      </h4>
      <a
        href={`https://worldlex.net/saml/login?idp=${client}`}
        className="btn btn-login"
      >
        <Translator file="user" name="user-loggin.sso.log.in.with.single.sign.on" />
      </a>
      <p>
        <Translator file="user" name="user-loggin.sso.problem.info" />
      </p>
    </Container>
  );
}

const Container = styled.div`
  width: 300px;
  margin: 0 auto;
  padding-top: 60px;
  font-size: 14px;
  text-align: center;

  img {
    display: block;
    margin: 0 auto 20px;
    width: 250px;
  }

  .btn-login {
    border-radius: 3px;
    margin-top: 20px;
    background-color: #003d47;
    border: 1px solid #547895;
    width: 100%;
    padding: 6px;
    color: #fff;
    font-size: 15px;
    margin: 30px 0;
  }
`;
